module.exports = __webpack_public_path__ + "static/media/4. Speaker Arshad Mohamed Ismail.9c5c1867.png";